import axios from 'axios'
import classNames from 'classnames'
import { isEmpty, omitBy, orderBy, pickBy, size } from 'lodash'
import pluralize from 'pluralize'
import PropTypes from 'prop-types'
import React from 'react'

import DateTime from 'components/DateTime'
import FirebaseImage from 'components/FirebaseImage'
import Heading from 'components/Heading'
import Image from 'components/Image'
import Link from 'components/Link'
import LoadingIndicator from 'components/LoadingIndicator'
import Meta from 'components/Meta'
import keys from 'constants/keys'
import paths from 'constants/paths'
import { db } from 'data'
import createReport from 'libs/create-report'
import getGoogleMapsAddressComponent from 'utils/get-google-maps-address-component'

import styles from './Reports.module.scss'

export default class Reports extends React.Component {
  static propTypes = {
    userEmail: PropTypes.string.isRequired,
  }

  state = {
    loading: true,
    reports: {},
  }

  componentWillMount() {
    //db.deleteFullReports()

    db.getFieldReports().then((fieldReportsSnapshot) => {
      const fieldReports = this.filterReports(fieldReportsSnapshot.val())

      db.getFullReports().then((fullReportsSnapshot) => {
        const fullReports = this.filterReports(fullReportsSnapshot.val())

        const fieldOnlyReports = omitBy(fieldReports, (value, key) => fullReports[key])

        const reports = fullReports

        const createReportPromises = []

        if (!isEmpty(fieldOnlyReports)) {
          Object.keys(fieldOnlyReports).forEach((id) => {
            const createReportPromise = createReport(id).then((response) => {
              if (response) reports[id] = response
            })

            createReportPromises.push(createReportPromise)
          })
        }

        Promise.all(createReportPromises).then(() => {
          const addressPromises = []

          //if (isEmpty(reports)) return

          Object.keys(reports).forEach((id) => {
            const { address, lat, lon } = reports[id]

            if (address || (!lat || !lon)) return

            const addressHandler = ((reportId) => {
              return (response) => {
                const result = response.data.results[0]

                if (!result) return

                const city = getGoogleMapsAddressComponent(result, 'locality') || null
                const state = getGoogleMapsAddressComponent(result, 'administrative_area_level_1') || null
                const country = getGoogleMapsAddressComponent(result, 'country', 'short_name') || null

                reports[reportId].address = [city, state, country].filter((val) => val).join(', ')
              }
            })(id)

            const addressPromise =
              axios
                .get(`https://maps.googleapis.com/maps/api/geocode/json?key=${keys.GOOGLE_MAPS}&latlng=${lat},${lon}`)
                .then(addressHandler)
                .catch((error) => console.log('error', error))

            addressPromises.push(addressPromise)
          })

          Promise.all(addressPromises).then(() => {
            // TODO: don't loose keys
            const reportsSorted = orderBy(reports, ['creationDate'], ['desc'])

            this.setState({
              loading: false,
              reports: reportsSorted,
            })
          })
        })
      })
    })
  }

  filterReports = (reports) => {
    const { userEmail } = this.props

    return pickBy(reports, (item) => {
      const { assessorEmail, images } = item

      return (
        // TODEBUG: disable next line
        assessorEmail === userEmail &&
        images
      )
    })
  }

  renderBody = () => {
    const { loading, reports } = this.state

    if (!reports || loading) {
      return (
        <LoadingIndicator />
      )
    }

    if (isEmpty(reports)) {
      return (
        <div>
          You have not created any reports yet.
        </div>
      )
    }

    return (
      <div className={classNames(styles.reports, 'uk-grid uk-grid-match uk-grid-stack uk-child-width-1-1 uk-child-width-1-3@m')}>
        {Object.keys(reports).map((id) => {
          const report = reports[id]

          const {
            address,
            assessmentDateStart,
            coverImageRef,
            coverImageUrl,
            id: reportId,
            images,
            title,
            //title = 'Unnamed Report',
          } = report

          const imagesCount = size(images)

          return (
            <div className="uk-grid-margin" key={id}>
              <div className="uk-card uk-card-default uk-card-small uk-card-hover">
                <Link
                  //to={`${paths.REPORTS}/${id}`}
                  to={`${paths.REPORTS}/${reportId}`}
                  className="uk-position-cover uk-position-z-index uk-margin-remove-adjacent" />
                {/*
                <header
                  style={{ backgroundImage: `url(${coverImageUrl})` }}
                  className={classNames(styles['reports--item--img'], 'uk-card-media-top uk-border-rounded')}
                />
                */}
                <header className={classNames(styles['reports--item--img2'], 'uk-card-media-top uk-border-rounded')}>
                  {/*<Image src={coverImageUrl} className={styles['reports--item--img2--img']} />*/}
                  <FirebaseImage
                    imageRef={coverImageRef}
                    thumbnail
                    thumbnailSize="512"
                    className={styles['reports--item--img2--img']}
                  />
                </header>
                <div className="uk-card-body">
                  <h2 className="uk-margin uk-h5 uk-margin-remove-adjacent uk-margin-small-bottom">
                    {isEmpty(title) ? 'Unnamed Report' : title}
                  </h2>
                  <div className="uk-margin uk-text-meta">
                    <DateTime value={assessmentDateStart} />
                  </div>
                  <div className="uk-margin">
                    <small>
                      <div className={styles['reports--item--address']}>
                        {address}
                      </div>
                      <div>
                        {pluralize('upload', imagesCount, true)}
                      </div>
                    </small>
                  </div>
                </div>
              </div>
            </div>
          )
        })}
      </div>
    )
  }

  render() {
    const title = 'Reports'

    return (
      <div className="Reports">
        <Meta title={title} />
        <div className="uk-container">
          <div className="uk-section uk-section-default">
            <Heading divided level="1">
              {title}
            </Heading>
            {this.renderBody()}
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/Reports/Reports.js